<script lang="ts">
	import { page } from '$app/stores';
	import bannerSeguros from '$lib/assets/images/blog/product-seguros.webp';
	import banner from '$lib/assets/images/blog/product.webp';
	import __ from '$lib/stores/TranslationStore';
	import { twMerge } from 'tailwind-merge';

	export let intent: string;
	let className: string = '';
	export { className as class };

	type BannerData = { desc: string; img: string; url: string };
	type BannerMap = { [key: string]: BannerData };

	const bannerMap: BannerMap = {
		'credito-habitacao': {
			desc: $__('Crédito habitação'),
			img: banner,
			url: '/credito-habitacao#contacto'
		},
		'credito-pessoal': {
			desc: $__('Crédito pessoal'),
			img: banner,
			url: '/credito-pessoal#contacto'
		},
		seguros: {
			desc: $__('Seguros'),
			img: bannerSeguros,
			url: '/seguros#contacto'
		}
	};

	$: bannerImg = bannerMap.hasOwnProperty(intent)
		? bannerMap[intent]
		: bannerMap['credito-habitacao'];
</script>

{#if $page.data?.language === 'pt'}
	<a
		class={twMerge('hidden md:inline-block', className)}
		href={bannerImg?.url}
        id="ainda_com_duvidas"
		target="_blank"
	>
		<img
			loading="lazy"
			width="970px"
			height="90px"
			class="mx-auto"
			src={bannerImg?.img}
			alt={bannerImg.desc}
		/>
	</a>
{/if}
